import { environment } from '../../../../../environments/environment';

export const INTERNAL_PLWC_SUPPLIERS_ENDPOINT = `${environment.apiBaseUrl}/internal/plwc/suppliers`;
export const INTERNAL_PLWC_SUPPLIER_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/suppliers/${companyId}`;
export const INTERNAL_PLWC_SUPPLIER_SUSPEND_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/suppliers/${companyId}/suspend`;
export const INTERNAL_PLWC_SUPPLIER_STATIC_LINK_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/supplier/${companyId}/static-link`;
export const INTERNAL_PLWC_SUPPLIER_BANK_ACCOUNTS_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/supplier/${companyId}/bank-accounts`;
export const INTERNAL_PLWC_SUPPLIER_BUYERS_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/supplier/${companyId}/buyers`;
export const INTERNAL_PLWC_SUPPLIER_INVITES_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/supplier/${companyId}/invites`;
export const INTERNAL_PLWC_SUPPLIER_USERS_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/supplier/${companyId}/users`;
export const INTERNAL_PLWC_SUPPLIER_TRANSACTIONS_ENDPOINT = (companyId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/supplier/${companyId}/transactions`;
